import { FETCH_ADMIN, FETCH_ADMIN_SUCCESS, FETCH_ADMIN_FAILURE, CLEAR_ADMIN } from '../actions';

const initialState = {
  admin: {},
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_ADMIN:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_ADMIN_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        admin: action.data
      };
    case FETCH_ADMIN_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        admin: {}
      };
    case CLEAR_ADMIN:
      return initialState;
    default:
      return state;
  }
}